// extracted by css-extract-rspack-plugin
export default {"personCell":"personCell-cTcG3V","contactCell":"contactCell-Oq8zDZ"};